import {
  Wifi,
  CircleParking,
  CookingPot,
  FileCheck2,
  Languages,
  Flower2,
  WashingMachine,
  Info,
  PawPrint,
  BedDouble,
  DoorClosed,
  Thermometer,
  ShowerHead,
  MapPin,
  TreePine,
  Milestone,
  Building2,
  Plane,
  Landmark,
} from "lucide-react";

const map = {
  Wifi,
  CircleParking,
  CookingPot,
  FileCheck2,
  Languages,
  Flower2,
  WashingMachine,
  Info,
  PawPrint,
  BedDouble,
  DoorClosed,
  Thermometer,
  ShowerHead,
  MapPin,
  TreePine,
  Milestone,
  Building2,
  Plane,
  Landmark,
};

export default function Icon({ name, className }) {
  const Cmp = map[name] || Info;
  return <Cmp className={className} />;
}
